export const debounceSearch = (func: any, delay: number) => {
  let timer: any;
  return (...arg: any) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => func(...arg), delay);
  };
};
